import React from 'react';
import {useSelector} from 'react-redux';

import {makeSelectDeviceName, makeSelectIotDeviceMergedWithConsumerProduct} from '../../state/selectors/consumer';
import DeviceImage from './DeviceImage';

const DeviceImageConnected = (props) => {
    const iotProduct = useSelector(makeSelectIotDeviceMergedWithConsumerProduct());
    const deviceName = useSelector(makeSelectDeviceName());
    const {device, holder} = iotProduct;

    return (
        <DeviceImage
            altMainImg={deviceName}
            altHolderImg={holder?.name || ''}
            device={device}
            holder={holder}
            {...props}
        />
    );
};

export default DeviceImageConnected;
